'use strict';
// TODO: This component should really be combined with common/CurrencyPicker
// We should make CurrencyPicker take a 'type' prop
// Where if type == dropdown, render dropdown select

'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _I18n = require('I18n');

var _I18n2 = _interopRequireDefault(_I18n);

var _reactRedux = require('react-redux');

var _UIDropdownSelect = require('UIComponents/dropdown/UIDropdownSelect');

var _UIDropdownSelect2 = _interopRequireDefault(_UIDropdownSelect);

var _CurrencySelectors = require('pricing-pages-unified-ui/selectors/CurrencySelectors');

var _ActiveCurrencyCodeActions = require('pricing-pages-unified-ui/actions/ActiveCurrencyCodeActions');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CurrencySelector = function CurrencySelector(_ref) {
  var activeCurrencyCode = _ref.activeCurrencyCode,
      availableCurrencies = _ref.availableCurrencies,
      onUpdateActiveCurrencyCode = _ref.onUpdateActiveCurrencyCode;

  var handleChange = function handleChange(event) {
    var value = event.target.value;

    onUpdateActiveCurrencyCode(value);
  };

  var getCurrencyOptions = function getCurrencyOptions() {
    return availableCurrencies.map(function (availableCurrency) {
      return {
        text: availableCurrency + ' (' + _I18n2.default.currencySymbols[availableCurrency].symbol + ')',
        value: availableCurrency
      };
    });
  };

  var shouldShowSelector = availableCurrencies && availableCurrencies.length > 1;

  if (!shouldShowSelector) {
    return _react2.default.createElement('span', { style: { minHeight: '40px' } });
  }

  return _react2.default.createElement(_UIDropdownSelect2.default, {
    className: 'display-inline-block',
    options: getCurrencyOptions(),
    onChange: handleChange,
    value: activeCurrencyCode
  });
};

var mapStateToProps = function mapStateToProps(state) {
  return {
    activeCurrencyCode: (0, _CurrencySelectors.activeCurrencySelector)(state),
    availableCurrencies: (0, _CurrencySelectors.availableCurrenciesSelector)(state)
  };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    onUpdateActiveCurrencyCode: function onUpdateActiveCurrencyCode(currency) {
      return dispatch((0, _ActiveCurrencyCodeActions.updateActiveCurrencyCode)({ currency: currency }));
    }
  };
};

exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(CurrencySelector);
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./js/components/contacts-confirmation-page/CurrencySelector.js
// module id = 676
// module chunks = 3 4